import styled from 'styled-components';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { NoSSR } from '@xing-com/crate-utils-no-ssr';
import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { scale190 } from '@xing-com/tokens';

import { useAdRefresh } from '../../hooks';

import { DisplayAdStartpageBillboard, DisplayAdStartpageRectangle01 } from '.';

export const SectionCol = styled.div`
  width: 100%;
  margin-bottom: ${scale190};
  display: flex;
  justify-content: center;

  @media ${mediaSmallOrTiny} {
    margin-bottom: 0;
  }
`;

const AdWrapper = styled.div`
  min-width: 300px;
  max-width: 336px;
  min-height: 280px;
  max-height: 300px;
  position: relative;
  z-index: 1;

  @media ${mediaConfined} {
    min-width: 728px;
    max-width: 970px;
    min-height: 250px;
    max-height: 300px;
  }
`;

export const DisplayAdStartpageSlot01: React.FC = () => {
  const isSmallScreen = useMatchMedia(mediaSmallOrTiny);

  const { refreshMobile, refreshDesktop } = useAdRefresh({
    isSmallScreen,
    slots: {
      mobile: 'rectangle01',
      desktop: 'billboard',
    },
  });

  return (
    <NoSSR>
      <SectionCol>
        <AdWrapper>
          {isSmallScreen ? (
            <DisplayAdStartpageRectangle01 refresh={refreshMobile} />
          ) : (
            <DisplayAdStartpageBillboard refresh={refreshDesktop} />
          )}
        </AdWrapper>
      </SectionCol>
    </NoSSR>
  );
};
